var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 78,
    viewBox: "0 0 327 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291 0.000244141C302.182 0.000244141 307.774 -0.000422097 312.185 1.82642C318.065 4.26226 322.737 8.93503 325.173 14.8157C327 19.2262 327 24.8176 327 36.0002V42.0002C327 53.1827 327 58.7743 325.173 63.1848C322.737 69.0652 318.065 73.7373 312.185 76.1731C307.774 78 302.183 78.0002 291 78.0002H36C24.8175 78.0002 19.2259 78 14.8154 76.1731C8.93501 73.7373 4.26301 69.0652 1.82715 63.1848C0.000270496 58.7743 0 53.1827 0 42.0002V36.0002C0 24.8177 0.000264055 19.2262 1.82715 14.8157C4.26299 8.93503 8.93479 4.26228 14.8154 1.82642C19.2259 -0.00046856 24.8175 0.000244141 36 0.000244141H95.4278C100.904 0.000244141 103.642 0.000244141 105.435 0.418614C109.103 1.27437 109.044 1.24485 111.954 3.63545C113.378 4.80418 116.819 9.29271 123.701 18.2698C132.385 29.5973 146.749 37.0002 163 37.0002C179.251 37.0002 193.615 29.5973 202.299 18.2697C209.181 9.29271 212.622 4.8042 214.045 3.63546C216.956 1.24487 216.897 1.27437 220.565 0.418616C222.358 0.000244141 225.096 0.000244141 230.572 0.000244141H291Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 50,
    width: 327,
    height: 28,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBg);
export default __webpack_public_path__ + "static/media/modalBG.51309bd0069386b6cc94904434bfbbec.svg";
export { ForwardRef as ReactComponent };